import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EntriesInfoComponent } from '../entries-info/entries-info.component';

@Component({
    selector: 'sb-paging',
    imports: [TranslateModule, EntriesInfoComponent],
    templateUrl: './paging.component.html',
    styleUrl: './paging.component.scss',
})
export class PagingComponent implements OnChanges {
    @Input() activePage: number = 1;
    @Input() itemCount: number;
    @Input() pageSize: number = 25;

    @Output() pageChange = new EventEmitter();

    pageCount: number = 1;
    pages: number[] = [];

    ngOnChanges(changes: SimpleChanges) {
        if (changes['itemCount']) {
            this.generatePages();
        }
    }

    changePage(pageNumber: number): void {
        if (pageNumber === this.activePage) {
            return;
        }

        this.activePage = pageNumber;
        this.pageChange.emit(pageNumber);
        this.generatePages();
    }

    changePageToNext(): void {
        const nextPage = this.activePage + 1;
        this.changePage(nextPage);
    }

    changePageToPrev(): void {
        const prevPage = this.activePage - 1;
        this.changePage(prevPage);
    }

    private generatePages() {
        if (this.itemCount) {
            this.pageCount = Math.ceil(this.itemCount / this.pageSize);
        } else {
            this.pageCount = 1;
        }

        this.pages.length = 0;
        for (
            let i = this.activePage > 3 ? this.activePage - 3 : 1;
            i <= (this.activePage < this.pageCount - 3 ? this.activePage + 3 : this.pageCount);
            ++i
        ) {
            this.pages.push(i);
        }
    }
}
